// src/screens/customer/customerPannel/helpsupport/TicketChat.jsx

import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Send } from "lucide-react";
import "../../../../assets/css/customer/customerPannel/helpsupport/TicketChat.css";
import axios from "axios";
import AppContext from "../../../../context/AppContext";

const TicketChat = () => {
  const { ticketId } = useParams();
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);

  const [messages, setMessages] = useState([
    {
      from: "admin",
      text: `Hello! You're chatting about ticket #${ticketId}. How can we help?`,
      time: now(),
    },
  ]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const bodyRef = useRef(null);

  function now() {
    return new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [messages]);

  //  fetch previous chat messages for this ticket
  useEffect(() => {
    viewPrevChat();
  }, [ticketId]);

  const viewPrevChat = () => {
    axios
      .get(`${baseUrl}/customer/help-support/viewChat`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { adconversation_id: ticketId },
      })
      .then((response) => {
        console.log(response.data);
        setMessages(response.data.allChats);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const send = () => {
    const trimmed = input.trim();
    if (!trimmed || sending) return;

    // const userMsg = { from: "user", text: trimmed, time: now() };
    // setMessages((prev) => [...prev, userMsg]);
    // setInput("");
    // setSending(true);

    setSending(true);

    const formdata = new FormData();
    formdata.append("message", input);
    formdata.append("sender", "customer");
    console.log(ticketId);
    formdata.append("adconversation_id", ticketId); //ticketId ki jga conversation id ay gi
    axios
      .post(`${baseUrl}/customer/help-support/sendChat`, formdata, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        setSending(false);
        setInput("");
        console.log(response.data);
        viewPrevChat();
      })
      .catch((error) => {
        console.log(error);
        setSending(false);
      });

    // Optional: send to backend
    // axios.post(`${baseUrl}/customer/help-support/chat/${ticketId}`, { message: trimmed })
    //   .catch(console.error);

    // setTimeout(() => {
    //   setMessages((prev) => [
    //     ...prev,
    //     {
    //       from: "admin",
    //       text: "Thanks for your message! An agent will respond shortly.",
    //       time: now(),
    //     },
    //   ]);
    //   setSending(false);
    // }, 1000);
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  return (
    <div className="tc-page">
      {/* Header */}
      <div className="tc-header">
        <button className="tc-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} strokeWidth={2} />
        </button>
        <div className="tc-header-info">
          <span className="tc-header-title">Ticket #{ticketId}</span>
          <span className="tc-header-sub">Live Support</span>
        </div>
        <div className="tc-online-dot" title="Online" />
      </div>

      {/* Messages */}
      <div className="tc-body" ref={bodyRef}>
        {messages.map((m, i) => (
          <div
            key={i}
            className={`tc-msg ${m.sender === "customer" ? "tc-msg-user" : "tc-msg-admin"}`}
          >
            <div className="tc-bubble">{m.message}</div>
            <span className="tc-time">{m.time}</span>
          </div>
        ))}

        {sending && (
          <div className="tc-msg tc-msg-admin">
            <div className="tc-bubble tc-typing">
              <span />
              <span />
              <span />
            </div>
          </div>
        )}
      </div>

      {/* Input */}
      <div className="tc-input-row">
        <textarea
          className="tc-input"
          placeholder="Type a message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKey}
          rows={1}
        />
        <button className="tc-send" onClick={send} disabled={!input.trim()}>
          <Send size={16} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
};

export default TicketChat;
